import jQuery from "jquery";

window.$ = jQuery; // workaround for https://github.com/parcel-bundler/parcel/issues/333

import downloadIcon from './download_button.png';
import previewIcon from './preview_button.png';
import "popper.js";
import "bootstrap";
import instantsearch from "instantsearch.js/es";
import {
  searchBox,
  infiniteHits,
  configure,
  refinementList,
} from "instantsearch.js/es/widgets";
import { history } from 'instantsearch.js/es/lib/routers';
import { simple } from 'instantsearch.js/es/lib/stateMappings';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { SearchClient as TypesenseSearchClient } from "typesense"; // To get the total number of docs

// Source: https://stackoverflow.com/a/901144/123545
const anchorParams = new Proxy(
  new URLSearchParams(window.location.hash.replace("#", "")),
  {
    get: (anchorParams, prop) => anchorParams.get(prop),
  }
);

let TYPESENSE_SERVER_CONFIG = {
  apiKey: process.env.TYPESENSE_SEARCH_ONLY_API_KEY, // Be sure to use an API key that only allows searches, in production
  nodes: [
    {
      host: anchorParams.host ? anchorParams.host : process.env.TYPESENSE_HOST,
      port: process.env.TYPESENSE_PORT,
      protocol: process.env.TYPESENSE_PROTOCOL,
    },
  ],
  numRetries: 8,
  useServerSideSearchCache: false,
};

const INDEX_NAME = process.env.TYPESENSE_COLLECTION_NAME;

async function getIndexSize() {
  let typesenseSearchClient = new TypesenseSearchClient({
    ...TYPESENSE_SERVER_CONFIG,
    useServerSideSearchCache: true,
  });
  let results = await typesenseSearchClient
    .collections(INDEX_NAME)
    .documents()
    .search({ q: "*" });

  return results["found"];
}

let indexSize;

(async () => {
  indexSize = await getIndexSize();
})();

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: TYPESENSE_SERVER_CONFIG,
  additionalSearchParameters: {
    preset: 'default',
  },
});

const routing = {
  router: history({
    createURL({ qsModule, routeState, location }) {
      const queryParameters = qsModule.stringify(routeState);
      const queryString = queryParameters ? `&${queryParameters}` : '';
      const cleanPath = location.pathname.replace(/\/$/, ''); // Remove trailing slash
      return `?s${cleanPath}${queryString}`;
    },
    parseURL({ qsModule, location }) {
      const queryString = location.search.slice(1); // Remove the leading '?'
      const parsed = qsModule.parse(queryString);
      // Remove the 's' parameter from the parsed state if it exists
      const { s, ...routeState } = parsed;
      if (Object.keys(routeState).length > 0) {
        $("#results-list").removeClass("d-none");
      }
      return routeState;
    },
  }),
  stateMapping: simple({
    stateToRoute(uiState) {
      return uiState[INDEX_NAME] || {};
    },
    routeToState(routeState) {
      return {
        [INDEX_NAME]: routeState,
      };
    },
  }),
};

const searchClient = typesenseInstantsearchAdapter.searchClient;
const search = instantsearch({
  searchClient,
  indexName: INDEX_NAME,
  routing,
  onStateChange({ uiState, setUiState }) {
    const indexUiState = uiState[INDEX_NAME];
    if (indexUiState && indexUiState.query === "") {    //handle empty search
    } else {
      $("#results-list").removeClass("d-none");
    }
    refinementChangeHandler(indexUiState.refinementList || {});     //handle refinement state change
    setUiState(uiState);     
    if (indexUiState.query) document.title = `Search results: ${indexUiState.query}`; //set the title to the search query
    else document.title = "BCCraneSafety search";
  },
});
function middleware({ }) {
  let listener;
  return {
    subscribe() {
      listener = (event) => { if (event.target) badgeClickHandler(event); }
      document.querySelectorAll('[data-refinement-name]').forEach(element => { element.addEventListener('click', listener); });
    },
  }
}

function refinementChangeHandler(refinementList) {
  document.querySelectorAll(`[data-refinement-name]`).forEach(button => { button.classList.remove('active'); });
  refinementList.category && refinementList.category.forEach(name => {
    let button = document.querySelectorAll(`[data-refinement-name="${name}"]`)[0];
    if (button) button.classList.add('active');       //only add the dark class back to actually selected classes.
  });
  refinementList.tags && refinementList.tags.forEach(name => {
    let button = document.querySelectorAll(`[data-refinement-name="${name}"]`)[0];
    if (button) button.classList.add('active');       //only add the dark class back to actually selected classes.
  });
}

function badgeClickHandler(event) {
  const refinementName = event.target.getAttribute('data-refinement-name');
  const refinementType = event.target.getAttribute('data-refinement-type');
  let button = document.querySelectorAll(`[data-refinement-name="${refinementName}"]`)[0];
  search.helper.clearRefinements(); //if the refinement is already activated, only clear all refinements, dont toggle after.
  if (!button.classList.contains('active')) search.helper.toggleFacetRefinement(refinementType, refinementName);
  $("#results-section").removeClass("d-none");
  search.helper.search();
}

function limitText(text, maxLength) {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
}

let tags;
let categories;
let debounceTimerId;
search.addWidgets([
  searchBox({
    container: "#searchbox",
    showSubmit: false,
    showReset: false,
    placeholder: "Search BC Crane Safety",
    autofocus: true,
    cssClasses: {
      input: "my-3 text-primary headings-font-weight searchbox",
    },
    queryHook(query, search) {
      if (debounceTimerId) {
        clearTimeout(debounceTimerId);
      }
      debounceTimerId = setTimeout(() => search(query), 100);
    },
  }),
  infiniteHits({
    container: "#hits",
    cssClasses: {
      list: "list-unstyled grid-container",
      item: "d-flex flex-column search-result-card",
      loadMore: "px-4 py-2 btn btn-primary mx-auto d-block mt-4 text-uppercase",
    },
    templates: {
      showMoreText: 'show more results',
      item(hit, { html, components }) {
        let snippet;
        //if no search query, use the post excerpt (if present), and only show the first 250 characters.
        if (search.helper.state.query === '') {
          //For the file downloads *only* please have either the excerpt display or nothing, when filtering (not searching)
          if (hit.post_type === 'wpfd_file') {
            snippet = limitText(hit.post_excerpt, 250);
          }
          else {
            //for all other post types, if there is an excerpt, use it, else use the first 250 characters of the post content.
            if (hit.post_excerpt) snippet = limitText(hit.post_excerpt, 250); 
            else snippet = limitText(hit.post_content, 250);
          }
        }
        //else, we have a query, and try to snippet the post content, if this fails (only one part), grab the first ~250 characters of post content.
        else {
          if ((components.Snippet({ hit, attribute: 'post_content' })).props.parts[0].length > 1) { //if the snippet has multiple parts, we have a text match, use the snippet
            snippet = html`... ${components.Snippet({ hit, attribute: 'post_content' })} ...` // wrap with elipsis
          } else {
            try { //if the snippet has only one part, grab the first 250 characters (ish) of the post content (no match)
              if (hit.post_excerpt) snippet = limitText(hit.post_excerpt, 250); 
              else snippet = limitText(hit.post_content, 250);
            }
            catch (e) {}
          }
        }
        function render(attribute) {
          if (components.Highlight({ hit, attribute }).props.parts.length == 0) {
            return html``;
          } else {
            const snippetElement = components.Snippet({ hit, attribute });
            return html`<p class="${attribute}_list">${snippetElement}</p>`;
          }
        }
        if (hit.post_type === 'wpfd_file') {
          return html`
            <div class="permalink d-flex flex-column h-100" target="_blank">
              <div class="content-wrapper d-flex flex-column py-3 flex-grow-1 px-3">
                <a href="${hit.permalink}" class="permalink" target="_blank">
                  <div class="text-primary headings-font-weight font-letter-spacing-loose">
                    <h5>${components.Highlight({ hit, attribute: 'post_title' })}</h5>
                  </div>
                </a>
              <div class="cattags my-1 headings-font-weight overflow-hidden">
                ${(() => {
                  return render("category");
                })()}
                ${(() => {
                  return render("tags");
                })()}
              </div>
                <div class="overflow-hidden">
                  <p class="mb-1 ext-primary result-text-weight">${snippet}</p>
                </div>
                  <div class="mt-auto">
                    <a target="_blank" href="${hit.permalink}" id="preview" class="d-inline-block">
                      <img class="preview-icon icon d-inline-block" src="${previewIcon}" alt="Preview Icon"></img>
                      <p class="preview d-inline-block headings-font-weight text-center">Preview</p>
                    </a>
                    <a target="_blank" href="${hit.download_link}" id="download" class="d-inline-block">
                      <img class="download-icon icon d-inline-block" src="${downloadIcon}" alt="Download Icon"></img>
                      <p class="download d-inline-block headings-font-weight text-center">Download</p>
                    </a>
                  </div>
              </div>
            </a>
          `;
        } else {
          return html`
          <a class="permalink d-flex flex-column h-100" href="${hit.permalink}" target="_blank">
            <div class="content-wrapper d-flex flex-column py-3 flex-grow-1 px-3">
              <div class="text-primary headings-font-weight font-letter-spacing-loose">
                <h5 class="mb-1">${components.Highlight({ hit, attribute: 'post_title' })}</h5>
              </div>
              <div class="cattags mb-1 headings-font-weight overflow-hidden">
                ${(() => {
                  return render("category");
                })()}
                ${(() => {
                  return render("tags");
                })()}
              </div>
              <div class="overflow-hidden">
                <p class="text-primary result-text-weight">${snippet}</p>
              </div>
            </div>
          </div>
        `;
        }
      },
      empty: "No results found for <q>{{ query }}</q>. Try another search term.",
    },
  }),
  tags = refinementList({
    container: "#tags-refinement-list",
    attribute: "tags",
    searchable: false,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      searchableInput: "font-letter-spacing-loose form-control form-control-sm mb-2 bg-secondary text-body",
      searchableSubmit: "d-none",
      searchableReset: "d-none",
      showMore: "btn btn-secondary btn-sm align-content-center",
      list: "list-unstyled mt-2",
      count: "ml-1",
      label: "d-flex align-items-center text-center text-capitalize text-body",
      checkbox: "mr-2",
    },
    templates: {
      showMoreText: '+ Show More',
    },
    transformItems(items) {
      return items.map(item => ({
        ...item,
        count: `(${item.count})`
      }));
    }
  }),
  categories = refinementList({
    container: "#category-refinement-list",
    attribute: "category",
    searchable: false,
    showMore: true,
    showMoreLimit: 40,
    cssClasses: {
      searchableInput: "font-letter-spacing-loose form-control form-control-sm mb-2 bg-secondary text-body",
      searchableSubmit: "d-none",
      searchableReset: "d-none",
      showMore: "btn btn-secondary btn-sm align-content-center",
      list: "list-unstyled mt-2",
      count: "ml-1",
      label: "d-flex align-items-center text-center text-capitalize text-body",
      checkbox: "mr-2",
    },
    templates: {
      showMoreText: '+ Show More',
    },
    transformItems(items) {
      return items
      .map(item => ({
        ...item,
        count: `(${item.count})`
      }));
    }
  }),
  configure({
    hitsPerPage: 15,
  }),
]);

function handleSearchTermClick(event) {
  const $searchBox = $("#searchbox input[type=search]");
  search.helper.clearRefinements();
  $searchBox.val(event.currentTarget.textContent);
  search.helper.setQuery($searchBox.val()).search();
}

search.start();
search.use(middleware);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('#searchbox input').focus();
});

//when the user starts typing, as long as they arnt in the footer (<div class="container_wrap footer_color" id="footer">), focus on the search box.
document.addEventListener('keydown', function (event) {
  // Check if any modifier keys are pressed
  const hasModifier = event.ctrlKey || event.altKey || event.metaKey;
  
  // Only proceed if no modifier keys are pressed and it's a single character key
  if (event.key.length === 1 && !hasModifier && !event.target.closest('#footer')) {
    document.querySelector('#searchbox input').focus();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});

document.querySelectorAll('.category_list .ais-Snippet-nonHighlighted')

$(function () {
  const $searchBox = $("#searchbox input[type=search]");
  // Handle demo search terms
  $(".clickable-search-term").on("click", handleSearchTermClick);
});

$(document).on('click', '.category_list .ais-Snippet-nonHighlighted', (e) => {
  e.stopPropagation();
  e.preventDefault();
  var refinementName = $(e.target).text();
  search.helper.toggleFacetRefinement("category", refinementName);
  search.helper.search();
});

$(document).on('click', '.tags_list .ais-Snippet-nonHighlighted', (e) => {
  e.stopPropagation();
  e.preventDefault();
  var refinementName = $(e.target).text();
  search.helper.toggleFacetRefinement("tags", refinementName);
  search.helper.search();
});
//on click of the show more button in the tags or categories, hide the show more button for that facet.
//hacky fix that depends on no more tags being created.
$(document).on('click', '.ais-RefinementList-showMore', (e) => {
  e.stopPropagation();
  e.preventDefault();
  $(e.target).hide();
});